import React, { CSSProperties, ReactNode } from "react";
import * as classes from "./loading-overlay.module.css";

interface ISpinner {
  style?: CSSProperties,
}

export function LoadingOverlay({ children }: { children: ReactNode }) {
  return (
    <>
      <div className={classes["overlay"]} />
      <div className={classes["loading-overlay"]}>
        {children}
      </div>
    </>
  );
}

export default function Spinner({ style }: ISpinner) {
  return (
    <div className="loading-spinner" style={{ fontSize: "20px", ...(style ?? {}) }}>
      <i className="fa-solid fa-spinner fa-spin-pulse" aria-hidden="true"></i>
    </div>
  );
}

/**
 * Usage Examples:
 *
 * 1. Using the loading spinner standalone
 * import Spinner from "loading";
 * <Spinner />
 *
 * 2. Using the spinner as a modal spinner with a modal overlay background:
 * import Spinner, { LoadingOverlay } from "loading";
 *
 * <LoadingOverlay>
 *   <Spinner />
 * <LoadingOverlay>
 *
 * 3. Using the loading overlay standalone as a modal overlay background:
 * import { LoadingOverlay } from "loading";
 *
 * <LoadingOverlay>
 *   ... your content here
 *   ... anything here is centralized on the page
 * </LoadingOverlay>
 */
